export interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '影视爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20man%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '88影视网画质真的没话说！我家里用的是4K电视，在这里看的电影画质特别清晰，一点都不模糊。资源更新也很快，新上映的大片很快就能看到高清版本，强烈推荐！',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '追剧达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20woman%20with%20glasses%2C%20warm%20smile%2C%20clean%20studio%20background%2C%20professional%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '一直在找能流畅看国产剧的平台，88影视网完美满足了我的需求！《庆余年》《大江大河》这些热播剧更新非常及时，播放一点也不卡顿。而且分类很清晰，找剧特别方便。',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '电影发烧友老张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle-aged%20Chinese%20man%2C%20confident%20expression%2C%20clean%20studio%20background%2C%20professional%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '作为一个看了二十多年电影的老影迷，88影视网的片源质量让我很惊喜。不仅有最新的院线大片，还有很多经典老片的高清修复版。画质清晰，音质也不错，观影体验非常棒！',
    date: '2026-07-20',
  },
  {
    id: 4,
    name: '全职妈妈小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20in%2030s%2C%20gentle%20smile%2C%20clean%20studio%20background%2C%20professional%20portrait&width=200&height=200&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '周末经常带着孩子一起看动画电影，88影视网的动漫专区太棒了！《熊出没》《深海》这些国产动画都有，画质清晰，孩子看得特别开心。而且没有乱七八糟的广告，这点做得非常好。',
    date: '2026-07-18',
  },
  {
    id: 5,
    name: '纪录片爱好者阿明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20man%20with%20casual%20style%2C%20friendly%20expression%2C%20clean%20studio%20background%2C%20professional%20portrait&width=200&height=200&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '88影视网的纪录片资源太丰富了！《地球脉动》《舌尖上的中国》这些殿堂级纪录片都有，而且都是高清版本。高清画质配大屏幕观看，那种震撼感真的无法用语言形容。',
    date: '2026-07-15',
  },
  {
    id: 6,
    name: '大学生小刘',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20female%20student%2C%20bright%20smile%2C%20clean%20studio%20background%2C%20professional%20portrait&width=200&height=200&seq=avatar-06&orientation=squarish',
    rating: 4,
    content: '宿舍网速一般，但在88影视网看剧基本不卡，这点真的很重要！高清不卡顿的体验在别的平台很难做到。《三体》这种特效大片看起来一点不模糊，非常满意。',
    date: '2026-07-12',
  },
];

export const stats = [
  { label: '影视资源', value: '10000+', icon: 'ri-film-line' },
  { label: '日均更新', value: '50+', icon: 'ri-refresh-line' },
  { label: '高清占比', value: '98%', icon: 'ri-4k-line' },
  { label: '活跃用户', value: '500万+', icon: 'ri-user-heart-line' },
];

export const contactInfo = {
  email: 'contact@88yingshi.com',
  phone: '400-888-8888',
  address: '北京市朝阳区影视产业园A座',
  wechat: '88yingshi_official',
  weibo: '@88影视网官方',
  workingHours: '周一至周日 9:00 - 21:00',
};

export const faqs = [
  {
    question: '88影视网是否需要注册才能观看？',
    answer: '88影视网提供免费高清影视在线观看服务，大部分内容无需注册即可直接观看。注册会员后可以享受收藏、历史记录、清晰度偏好设置等更多个性化功能，让您的观影体验更加便捷舒适。',
  },
  {
    question: '为什么有些影片播放时会卡顿？',
    answer: '88影视网采用先进的CDN加速技术和智能码率调节系统，在绝大多数网络环境下都能保证流畅的高清观影体验。如果遇到卡顿情况，建议您检查本地网络连接，或尝试切换至较低的清晰度档位。我们的技术团队7×24小时监控服务质量，确保高清不卡顿的观影体验。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '88影视网全面支持PC端、平板电脑和手机端浏览器访问，适配各种屏幕尺寸。推荐使用Chrome、Edge、Safari等主流浏览器获得最佳高清在线观看体验。未来我们将推出专属APP，带给您更加便捷的观影方式。',
  },
  {
    question: '影片更新频率如何？',
    answer: '我们的内容团队全天候追踪最新影视资源，热播剧集一般在播出后2小时内更新，新上映电影也会在最短时间内上线高清版本。88影视网承诺为您提供最新、最快、最全的高清影视在线观看服务。',
  },
  {
    question: '画质最高支持多少分辨率？',
    answer: '88影视网支持从标清到4K超清的多档画质选择。大部分影片提供1080P高清和4K超清版本，满足不同设备和网络环境下的观影需求。我们的超清影视播放技术确保画面清晰不模糊，色彩还原真实自然。',
  },
  {
    question: '88影视网是否完全免费？',
    answer: '88影视网始终坚持免费高清影视在线观看的理念，所有内容均可免费观看。我们通过合法合规的方式运营，致力于为广大用户提供优质的高清视频网站服务。未来如有任何政策调整，我们将提前公告通知。',
  },
];